declare namespace $ {

	type $yuf_carousel_image__uri_yuf_carousel_1 = $mol_type_enforce<
		ReturnType< $yuf_carousel['url'] >
		,
		ReturnType< $yuf_carousel_image['uri'] >
	>
	type $yuf_carousel_image__error_yuf_carousel_2 = $mol_type_enforce<
		ReturnType< $yuf_carousel['url_error'] >
		,
		ReturnType< $yuf_carousel_image['error'] >
	>
	export class $yuf_carousel extends $mol_view {
		Empty( id: any): $mol_icon_camera_off
		url( id: any): string
		url_error( id: any, next?: any ): any
		Image( id: any): $yuf_carousel_image
		images( ): readonly($mol_view)[]
		event_move( next?: any ): any
		event_scroll( next?: any ): any
		index( next?: number ): number
		scroll_x( next?: number ): number
		auto_scroll( ): boolean
		minimal_height( ): number
		ids( ): readonly(string)[]
		empty( id: any): readonly($mol_view)[]
		sub( ): ReturnType< $yuf_carousel['images'] >
		event( ): ({ 
			mousemove( next?: ReturnType< $yuf_carousel['event_move'] > ): ReturnType< $yuf_carousel['event_move'] >,
			scroll( next?: ReturnType< $yuf_carousel['event_scroll'] > ): ReturnType< $yuf_carousel['event_scroll'] >,
		})  & ReturnType< $mol_view['event'] >
	}
	
	export class $yuf_carousel_image extends $mol_image {
		error( next?: any ): any
		minimal_height( ): number
		event( ): ({ 
			error( next?: ReturnType< $yuf_carousel_image['error'] > ): ReturnType< $yuf_carousel_image['error'] >,
		})  & ReturnType< $mol_image['event'] >
	}
	
}

//# sourceMappingURL=carousel.view.tree.d.ts.map